import type { EditorMargin } from 'models/sitecore';
import { is } from 'utils/helpers';

const MARGINS: Record<EditorMargin, string> = {
	None: '',
	Half: 'mt-r-md',
	Single: 'mt-r-xl',
	Double: 'mt-r-3xl',
};

export function getEditorMargin(
	editorMargin: { margin?: EditorMargin } | EditorMargin | undefined,
	fallback: EditorMargin = 'Double',
): string | undefined {
	const key = is.string(editorMargin) ? editorMargin : editorMargin?.margin;
	return MARGINS[key || fallback] || undefined;
}
